<style>
    .mtapp-contentData-selected button[disabled] {
        border-color: rgb(165, 165, 165) !important;
    }

    @keyframes shakeup {
        0% {
            transform: translateY(0);
        }
        25% {
            transform: translateY(-2px);
        }
        50% {
            transform: translateY(-4px);
        }
        75% {
            transform: translateY(-6px);
        }
        100% {
            transform: translateY(-8px);
        }
    }
    .shake-up {
        animation: shakeup 0.2s ease-in-out forwards;
    }

    @keyframes shakedown {
        0% {
            transform: translateY(0);
        }
        25% {
            transform: translateY(2px);
        }
        50% {
            transform: translateY(4px);
        }
        75% {
            transform: translateY(6px);
        }
        100% {
            transform: translateY(8px);
        }
    }
    .shake-down {
        animation: shakedown 0.2s ease-in-out forwards;
    }
</style>

<script>
    import { preventDefault } from 'svelte/legacy';

    import { onMount, untrack } from 'svelte';
    import { createEventDispatcher } from 'svelte';
    import { deepCopy } from '../../../deepCopy.js';
    import { loadingImage } from '../../../loadingImage.js';
    import { isPlainObject } from '../../../isPlainObject.js';
    import { modalConfirm } from '../../../modalConfirm.js';
    import { getDataApiUrl } from '../../../getDataApiUrl.js';

    // ----------------------------------------
    // props で受け取る変数
    
    /**
     * @typedef {Object} Props
     * @property {any} mtappVars - ----------------------------------------
     * @property {any} id
     * @property {any} item
     */

    /** @type {Props} */
    let { mtappVars: mtappVarsProp, id: idProp, item = $bindable() } = $props();
    // mtappVars と id はコンポーネント生存中は不変（id は {#each (item.id)} のキー）。
    // untrack で初期値に固定し、以降は非リアクティブなローカル定数として扱う。
    const mtappVars = untrack(() => mtappVarsProp);
    const id = untrack(() => idProp);

    // ----------------------------------------
    // 親(MultiFieldPro)コンポーネント更新用イベント
    // ----------------------------------------
    const dispatch = createEventDispatcher();
    const triggerInputChange = () => {
        dispatch('inputchange');
    };

    // ----------------------------------------
    // ローカル変数
    // ----------------------------------------
    const staticPath = mtappVars.static_path;
    const fieldLabel = item.label;
    const targetFieldName = '';

    // 各種ID
    const modalId = 'modal-' + id;
    const modalEditId = 'modal-edit-' + id;
    const tableId = 'table-' + id;
    const selectedId = 'selected-' + id;
    const iframeId = 'iframe-' + id;
    const searchInputId = 'search-' + id;

    let modalSelectElement = null;
    let modalSelect = null;
    let modalEditElement = null;
    let modalEdit = null;
    let iframeElement = null;

    // responseItems の配列にセットしたものが選択モーダルに表示される
    let responseItems = $state([]);
    let responseTotalResults = $state(0);
    let selectedItems = $state([]);
    let stash = [];
    let filtered = $state(false);
    let createMode = $state(false);
    let radioData = $state(null);
    let currentOffset = $state(0);
    let searchText = $state('');
    let allContentDataIds = $state([]);







    // ----------------------------------------
    // メソッド
    // ----------------------------------------

    /**
     * 引数の値が数値に変換可能かチェックします。
     * @param value
     * @returns {boolean}
     */
    function isNumeric(value) {
        return !isNaN(value);
    }

    /**
     * キャンセルして選択モーダルを閉じます。保存する値は更新せずに元に戻します。
     */
    function cancel() {
        item.data = stash;
        currentOffset = 0;
        showSelectedDataLabel();
        clean();
        triggerInputChange();
    }

    /**
     * キャンセルして編集モーダルを閉じます。
     */
    function cancelEdit() {
        currentOffset = 0;
        iframeElement.removeAttribute('src');
        clean();
        showSelectedDataLabel();
    }

    /**
     * チェックボックスがチェックされたときコンテンツデータIDを保存する値に追加します。
     *
     * @param {object} contentData
     */
    function checkboxChange(contentData) {
        if (contentData.checked) {
            item.data.push(Number(contentData.id));
        } else {
            item.data = item.data.filter((id) => id !== Number(contentData.id));
        }
        item.data = item.data;
        triggerInputChange();
    }

    /**
     * 動的に扱う変数をリセットして元に戻します。
     */
    function clean() {
        radioData = null;
        responseItems = [];
        stash = [];
        filtered = false;
        createMode = false;
        searchText = '';
    }

    /**
     * 選択したコンテンツデータを上に移動します。
     *
     * @param {number} i
     */
    function contentDataUp(i) {
        selectedItems[i - 1].shakeDown = true;
        selectedItems[i].shakeUp = true;
        selectedItems = selectedItems;
        setTimeout(() => {
            item.data.splice(i - 1, 2, item.data[i], item.data[i - 1]);
            selectedItems.splice(i - 1, 2, selectedItems[i], selectedItems[i - 1]);
            delete selectedItems[i - 1].shakeUp;
            delete selectedItems[i].shakeDown;
            selectedItems = selectedItems;
            // item.data内のIDで有効なものだけ残す
            const validIds = selectedItems.map((_item) => _item.id);
            item.data = item.data.filter((id) => validIds.includes(id));
            triggerInputChange();
        }, 200);
    }

    /**
     * 選択したコンテンツデータを下に移動します。
     *
     * @param {number} i
     */
    function contentDataDown(i) {
        selectedItems[i].shakeDown = true;
        selectedItems[i + 1].shakeUp = true;
        selectedItems = selectedItems;
        setTimeout(() => {
            item.data.splice(i, 2, item.data[i + 1], item.data[i]);
            selectedItems.splice(i, 2, selectedItems[i + 1], selectedItems[i]);
            delete selectedItems[i].shakeUp;
            delete selectedItems[i + 1].shakeDown;
            selectedItems = selectedItems;
            // item.data内のIDで有効なものだけ残す
            const validIds = selectedItems.map((_item) => _item.id);
            item.data = item.data.filter((id) => validIds.includes(id));
            triggerInputChange();
        }, 200);
    }

    /**
     * 選択したコンテンツデータを削除します。
     *
     * @param {number} i
     */
    function contentDataRemove(i) {
        modalConfirm({
            type: 'warning',
            title: '確認',
            content: '削除しますか？',
            okButtonLabel: 'OK',
            cancelButtonLabel: 'キャンセル',
            callback: function () {
                item.data.splice(i, 1);
                selectedItems.splice(i, 1);
                selectedItems = selectedItems;
                triggerInputChange();
            }
        });
    }

    /**
     * コンテンツデータのステータスに応じたアイコンを表示します。
     *
     * @param {string} status
     */
    function contentDataStatusIcon(status) {
        let iconHtml = '';
        switch (status) {
            case 'Publish':
                iconHtml = window.mtappStatusIcons['Publish'];
                break;
            case 'Unpublish':
                iconHtml = window.mtappStatusIcons['Unpublish'];
                break;
            case 'Review':
                iconHtml = window.mtappStatusIcons['Review'];
                break;
            case 'Future':
                iconHtml = window.mtappStatusIcons['Scheduled'];
                break;
            case 'Draft':
                iconHtml = window.mtappStatusIcons['Draft'];
                break;
        }
        return iconHtml;
    }

    /**
     * コンテンツデータの新規作成用のURLを生成します。
     *
     * @return {string}
     */
    function createContentDataUrl() {
        const fieldId = id;
        const magicTokenElement = document.querySelector('[magic_token]');
        const magicToken = magicTokenElement ? magicTokenElement.value : '';
        const contentDataId = mtappVars.content_data && mtappVars.content_data.id ? mtappVars.content_data.id : 0;
        const url = new URL(window.CMSScriptURI, location.origin);
        url.searchParams.append('__mode', 'view');
        url.searchParams.append('magic_token', magicToken);
        url.searchParams.append('content_type_id', item.contentTypeId);
        url.searchParams.append('_type', 'content_data');
        url.searchParams.append('blog_id', item.siteId);
        url.searchParams.append('type', `content_data_${item.contentTypeId}`);
        url.searchParams.append('mtapp_source_field_id', fieldId);
        url.searchParams.append('mtapp_source_id', contentDataId);
        url.searchParams.append('mtapp_target_field_name', targetFieldName);
        return url.toString();
    }

    /**
     * コンテンツデータを新規作成するモーダルを開きます。
     *
     * @returns {boolean}
     */
    function createContentData() {
        const createUrl = createContentDataUrl();

        // iframeを非表示にしてから、src属性を設定し、ロードイベントを設定
        iframeElement.style.display = 'none';
        iframeElement.src = createUrl + '&mtapp_dialog_edit=1';
        iframeElement.onload = function () {
            this.style.display = '';
        };

        const modalHeight = window.innerHeight - 200;
        const modalBody = document.querySelector('#' + modalEditId + ' .modal-body');

        modalBody.style.height = modalHeight + 'px';
        modalBody.style.maxHeight = modalHeight + 'px';

        iframeElement.style.height = modalHeight + 'px';
        iframeElement.style.maxHeight = modalHeight + 'px';
        createMode = true;
        modalEdit.show();
        return false;
    }

    /**
     * コンテンツデータを編集するウィンドウを開く
     *
     * @param {number} id コンテンツID
     * @returns void
     */
    function editContentData(id) {
        const editUrl = editContentDataUrl(id);

        // iframeを非表示にしてから、src属性を設定し、ロードイベントを設定
        iframeElement.style.display = 'none';
        iframeElement.src = editUrl + '&mtapp_dialog_edit=1';
        iframeElement.onload = function () {
            iframeElement.style.display = '';
        };

        const modalHeight = window.innerHeight - 200;
        modalEditElement.querySelector('.modal-body').style.cssText = `height: ${modalHeight}px; max-height: ${modalHeight}px;`;
        iframeElement.style.cssText = `height: ${modalHeight}px; max-height: ${modalHeight}px;`;

        // Bootstrap 5のモーダルを初期化して表示
        modalEdit.show();
    }

    /**
     * コンテンツデータを編集するページのURLを返します。
     *
     * @param editContentDataId
     * @returns {string}
     */
    function editContentDataUrl(editContentDataId) {
        const fieldId = id;
        const contentDataId = isNumeric(mtappVars?.content_data?.id) ? Number(mtappVars.content_data.id) : 0;
        return `${window.CMSScriptURI}?__mode=view&content_type_id=${item.contentTypeId}&_type=content_data&blog_id=${item.siteId}&id=${editContentDataId}&mtapp_source_field_id=${fieldId}&mtapp_source_id=${contentDataId}&mtapp_target_field_name=${targetFieldName}`;
    }

    /**
     * モーダルで扱うすべてのコンテンツデータのIDを取得しておきます。
     */
    async function getAllContentDataIds() {
        const getIdsParams = new URLSearchParams({
            limit: '1000000',
            fields: 'id'
        });

        try {
            const apiUrl = getDataApiUrl();
            const url = `${apiUrl}/sites/${item.siteId}/contentTypes/${item.contentTypeId}/data?${getIdsParams}`;
            const response = await fetch(url, {
                method: 'GET'
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();

            if (data.error) {
                alert(data.error.message);
                return;
            }

            allContentDataIds = data.items.map((item) => Number(item.id));
        } catch (error) {
            console.error('Error fetching content data IDs:', error);
            alert('コンテンツデータIDの取得に失敗しました: ' + error.message);
        }
    }

    /**
     * 現在のページから前のページのデータを取得します。
     * currentOffsetをpaginateLimit分だけ減らし、listContentData関数を呼び出してデータを更新します。
     */
    function getPrevPage() {
        currentOffset = currentOffset - paginateLimit;
        listContentData();
    }

    /**
     * 現在のページから次のページのデータを取得します。
     * currentOffsetをpaginateLimit分だけ増やし、listContentData関数を呼び出してデータを更新します。
     */
    function getNextPage() {
        currentOffset = currentOffset + paginateLimit;
        listContentData();
    }

    /**
     * モーダルウィンドウを開くための関数です。モーダルウィンドウ内にコンテンツデータをリスト表示し、
     * 高さを調整してからモーダルを表示します。
     * `listContentData` 関数を呼び出してデータを取得した後、モーダルが表示されるタイミングで
     * モーダルのサイズを画面の高さに合わせて調整します。
     */
    function modalOpen() {
        stash = deepCopy(item.data);

        if (item.radio) {
            radioData = item.data[0];
        }
        listContentData({}, function () {
            const handleModalShown = function () {
                const modalHeight = window.innerHeight - 200;
                const modalBody = modalSelectElement.querySelector('.modal-body');
                modalBody.style.height = modalHeight + 'px';
                modalBody.style.maxHeight = modalHeight + 'px';
            };

            // イベントリスナをクリーンアップしてから、新しいものを追加
            modalSelectElement.removeEventListener('show.bs.modal', handleModalShown);
            modalSelectElement.addEventListener('show.bs.modal', handleModalShown);

            // モーダルを表示
            modalSelect.show();
        });
    }

    /**
     * コンテンツデータのリストをData APIを通じて取得し、取得したデータを加工してからコールバック関数を実行します。
     * responseItems の配列にセットしたものが選択モーダルに表示されます。
     *
     * @param {Object} params - Data APIに送信する追加のパラメータ。
     * @param {Function} callback - データ取得後に実行するコールバック関数。
     *
     * @returns {boolean} - 処理が正常に開始された場合はtrue、そうでない場合はfalseを返します。
     */
    async function listContentData(params = {}, callback = null) {
        if (typeof item.siteId === 'undefined') {
            alert('The "siteId" property in "item.siteId" is required.');
            return false;
        }
        if (typeof item.contentTypeId === 'undefined') {
            alert('The "contentTypeId" property in "item.contentTypeId" is required.');
            return false;
        }

        loadingImage('show');

        try {
            const urlParams = new URLSearchParams();
            const requestParamsObj = requestParams(params);

            // パラメータをURLSearchParamsに変換
            for (const [key, value] of Object.entries(requestParamsObj)) {
                if (value !== null && value !== undefined) {
                    urlParams.append(key, String(value));
                }
            }

            const apiUrl = getDataApiUrl();
            const url = `${apiUrl}/sites/${item.siteId}/contentTypes/${item.contentTypeId}/data?${urlParams}`;
            const response = await fetch(url, {
                method: 'GET'
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();

            if (data.error) {
                alert(data.error.message);
                loadingImage('hide');
                return;
            }

            // ページネーションで利用されるコンテンツデータのリストの全件数をセット
            responseTotalResults = Number(data.totalResults);

            // 選択モーダルに表示するコンテンツデータのリストをセット
            responseItems = data.items.map((responseItem) => {
                responseItem.checked = item.data.includes(Number(responseItem.id));
                responseItem.associativeData = {};
                if (responseItem.data) {
                    responseItem.data.forEach((field) => {
                        responseItem.associativeData['field_' + field.id] = field.data || '';
                    });
                }
                return responseItem;
            });

            if (typeof callback === 'function') {
                callback(data);
            }

            loadingImage('hide');
        } catch (error) {
            console.error('Error fetching content data:', error);
            alert('コンテンツデータの取得に失敗しました: ' + error.message);
            loadingImage('hide');
        }
    }

    /**
     * ラジオボタンがチェックされたときコンテンツデータIDを保存する値にセットします。
     */
    function radioChange() {
        item.data.length = 0;
        item.data.push(radioData);
        item.radioData = radioData;
        item = item;
        triggerInputChange();
    }

    /**
     * Data API に渡すパラメータオブジェクトを生成する
     * @param {object} params
     * @returns {object}
     */
    function requestParams(params = {}) {
        let urlParams = {
            limit: paginateLimit,
            offset: currentOffset
        };
        if (!item.includeDraft) {
            urlParams.status = 'Publish';
        }
        // オプションの status パラメータがある場合は urlParams.status を上書き
        if (typeof item.status === 'string') {
            urlParams.status = item.status.replace(/\s/g, '');
        }
        // オプションの params を urlParams にマージ
        if (isPlainObject(item.params)) {
            Object.assign(urlParams, item.params);
        }
        // 引数の params を urlParams にマージ
        if (isPlainObject(params)) {
            Object.assign(urlParams, params);
        }
        return urlParams;
    }

    /**
     * 対象となるコンテンツデータすべてを取得、表示します。
     */
    function resetFilter() {
        currentOffset = 0;
        filtered = false;
        searchText = '';
        listContentData();
    }

    /**
     * 検索ボックスの値と表示コンテンツデータをリセットします。
     */
    function resetSearch() {
        resetFilter();
    }

    /**
     * 選択したIDを保存します。
     * ラジオボタンの場合は、選択されたIDのみを保存します。
     * currentOffsetを0にリセットし、選択されたデータのラベルを表示する関数を呼び出した後、
     * clean関数で不要なプロパティを削除し、triggerInputChange関数で入力変更イベントをトリガーします。
     */
    function saveIds() {
        currentOffset = 0;
        showSelectedDataLabel();
        clean();
        triggerInputChange();
    }

    /**
     * 検索して選択モーダルの項目をフィルタします。
     */
    async function search() {
        if (!searchText) {
            return;
        }
        currentOffset = 0;
        filtered = false;

        const searchParams = new URLSearchParams({
            search: searchText,
            blog_id: String(item.siteId),
            cdSearch: '1'
        });

        try {
            const apiUrl = getDataApiUrl();
            const url = `${apiUrl}/search?${searchParams}`;
            const response = await fetch(url, {
                method: 'GET'
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();

            if (data.error) {
                alert(data.error.message);
                return;
            }

            if (data.items.length === 0) {
                responseItems = [];
                return;
            }

            responseItems = data.items
                .filter((responseItem) => allContentDataIds.includes(Number(responseItem.id)))
                .map((responseItem) => {
                    // item.idがitem.dataに含まれているかをチェック
                    if (item.data.includes(Number(responseItem.id))) {
                        // 条件に合致する場合は、checkedプロパティを追加
                        return { ...responseItem, checked: true };
                    }
                    // 条件に合致しない場合は、元のitemをそのまま返す
                    return responseItem;
                });
        } catch (error) {
            console.error('Error searching content data:', error);
            alert('検索に失敗しました: ' + error.message);
        }
    }

    /**
     * 新規作成モーダルを閉じて選択モーダルを新規作成したコンテンツデータをチェックした状態で開きます。
     */
    function select() {
        const iframeContents = iframeElement.contentDocument || iframeElement.contentWindow.document;
        const savedChanges = iframeContents.getElementById('saved-changes');
        const savedAdded = iframeContents.getElementById('saved-added');

        if ((!savedChanges || savedChanges.style.display === 'none') && (!savedAdded || savedAdded.style.display === 'none')) {
            alert(mtappVars.translate['You have to save the new content data first.']);
            return false;
        }

        const newIdInput = iframeContents.querySelector('[name="id"]');
        const newId = Number(newIdInput.value);
        if (newId) {
            if (item.radio) {
                radioData = newId;
                item.data = [newId];
            } else if (item.maxCount === 0 || item.maxCount > item.data.length) {
                item.data = [newId, ...item.data];
            }
        }

        // インラインスタイルや属性をクリアする
        iframeElement.removeAttribute('src');

        // Bootstrap 5モーダルを非表示にする
        modalEdit.hide();

        // 他の関数やメソッドを呼び出し
        currentOffset = 0;
        clean();
        modalOpen();
    }

    /**
     * 選択したコンテンツデータだけ選択モーダルに表示します。
     */
    function selectedFilter() {
        searchText = '';
        filtered = true;
        currentOffset = 0;
        if (typeof item.data !== 'undefined' && Array.isArray(item.data)) {
            listContentData({
                limit: 200,
                includeIds: item.data.join(',')
            });
        }
    }

    /**
     * 選択されたデータのラベルを表示します。
     * item.dataに保存されたIDのリストを基に、DataAPIを使用して対応するコンテンツデータを取得します。
     * 取得したデータはIDのリストに従って並べ替えられ、表示のために使用されます。
     * item.dataにIDが存在しない場合は何もしません。
     * データ取得中はローディングイメージが表示され、取得後は非表示になります。
     * データ取得に失敗した場合はエラーメッセージが表示されます。
     */
    async function showSelectedDataLabel() {
        if (item.data.length === 0) {
            return false;
        }

        const urlParams = new URLSearchParams({
            includeIds: item.data.join(','),
            fields: 'id,label,status,data',
            limit: '200',
            offset: '0'
        });

        loadingImage('show');

        try {
            const apiUrl = getDataApiUrl();
            const url = `${apiUrl}/sites/${item.siteId}/contentTypes/${item.contentTypeId}/data?${urlParams}`;
            const response = await fetch(url, {
                method: 'GET'
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();

            if (data.error) {
                alert(data.error.message);
                loadingImage('hide');
                return;
            }

            // 取得したアイテムをitem.dataの順番に並び替え
            const sortIds = [...item.data];
            selectedItems = data.items.sort((a, b) => {
                return sortIds.indexOf(a.id) - sortIds.indexOf(b.id);
            });

            item.response = {
                items: selectedItems.map((selectedItem) => {
                    selectedItem.associativeData = {}; // v2 では associatedData に変更されている
                    if (selectedItem.data) {
                        // selectedItem.data.forEach((field) => {
                        //     selectedItem.associativeData['field_' + field.id] = field.data || '';
                        // });
                        delete selectedItem.data;
                    }
                    return selectedItem;
                }),
                totalResults: selectedItems.length
            };

            // item.data内のIDで有効なものだけ残す
            const validIds = selectedItems.map((_item) => _item.id);
            item.data = item.data.filter((id) => validIds.includes(id));

            triggerInputChange();
            loadingImage('hide');
        } catch (error) {
            console.error('Error fetching selected data labels:', error);
            alert('選択済みデータの取得に失敗しました: ' + error.message);
            loadingImage('hide');
        }
    }

    onMount(() => {
        let needTrigger = false;
        // デフォルト設定をマージ
        const defaultOptions = {
            type: 'contentData',
            label: 'コンテンツデータ',
            radio: false,
            modalEdit: false,
            modalCreate: false,
            includeDraft: false,
            status: null,
            params: null,
            dataLabelName: 'データラベル',
            selectButtonLabel: '',
            createButtonLabel: '',
            paginate: {
                limit: 20
            },
            options: [],
            data: []
        };
        item = { ...defaultOptions, ...item };

        // 検索用にすべてのコンテンツデータのIDを取得しておく
        getAllContentDataIds();

        // 選択用のモーダル要素を取得・初期化
        modalSelectElement = document.getElementById(modalId);
        modalSelect = new bootstrap.Modal(modalSelectElement);

        // 新規作成・編集用のモーダル要素を取得・初期化
        modalEditElement = document.getElementById(modalEditId);
        modalEdit = new bootstrap.Modal(modalEditElement);

        // 新規作成・編集用のiframe要素を取得
        iframeElement = document.getElementById(iframeId);

        // item.data が配列でない場合は空配列をセット
        if (Array.isArray(item?.data) === false) {
            item.data = [];
            needTrigger = true;
            triggerInputChange();
        }

        // item.maxCount の初期値をセット
        item.maxCount = isNumeric(item?.maxCount) ? Number(item.maxCount) : 0;

        // radio の場合
        if (item.radio) {
            radioData = item.data.length ? item.data[0] : null;
            if (typeof item.radioData === 'undefined') {
                item.radioData = radioData;
                needTrigger = true;
            }
        }

        if (needTrigger) {
            triggerInputChange();
        }

        // 保存されているコンテンツデータを表示
        showSelectedDataLabel();
    });
    // ----------------------------------------
    // リアクティブな変数
    // ----------------------------------------

    /**
     * 最大値に到達したかどうかを判定するフラグ
     * @type {boolean}
     */
    let isDisabled = $derived(isNumeric(item.maxCount) && Number(item.maxCount) > 1 && item.data.length >= item.maxCount);
    /**
     * コンテンツデータを選択するウィンドウを開くボタンのラベル
     * @type {string}
     */
    let selectButtonLabel = $derived((() => {
        if (item.selectButtonLabel) {
            return item.selectButtonLabel;
        }
        if (mtappVars?.me?.preferred_language === 'ja') {
            return fieldLabel + 'を選択';
        } else {
            return 'Select ' + fieldLabel;
        }
    })());
    /**
     * コンテンツデータを新規作成するウィンドウを開くボタンのラベル
     * @type {string}
     */
    let createButtonLabel = $derived((() => {
        if (item.createButtonLabel) {
            return item.createButtonLabel;
        }
        if (mtappVars?.me?.preferred_language === 'ja') {
            return '新しい' + fieldLabel + 'を作成';
        } else {
            return 'Create a new ' + fieldLabel;
        }
    })());
    /**
     * ページネーションの limit 値
     * @type {number}
     */
    let paginateLimit = $derived(Number(item.paginate?.limit) || 20);
    /**
     * ページネーションの現在のページ
     * @type {number}
     */
    let currentPage = $derived(currentOffset / paginateLimit + 1);
    /**
     * ページネーションの最大ページ数
     * @type {number}
     */
    let totalPages = $derived(Math.ceil(responseTotalResults / paginateLimit));
</script>

<div data-handle={item.type}>
    <!-- 選択したコンテンツデータを表示 -->
    <div class="mb-3">
        {#if item.data.length}
            <div id={selectedId} class="mtapp-contentData-selected">
                {#each selectedItems as selectedItem, loopIndex}
                    <div
                        class="btn-group w-100 mb-2"
                        class:shake-up={typeof selectedItem.shakeUp !== 'undefined' && selectedItem.shakeUp}
                        class:shake-down={typeof selectedItem.shakeDown !== 'undefined' && selectedItem.shakeDown}
                        role="group">
                        {#if item.modalEdit}
                            <button
                                type="button"
                                class="btn btn-default w-100 text-start mtapp-selected-item"
                                onclick={preventDefault(() => editContentData(selectedItem.id))}
                                data-content-data-id={selectedItem.id}>
                                <span class="icon">{@html contentDataStatusIcon(selectedItem.status)}</span>
                                <span class="label">{selectedItem.label}</span>
                            </button>
                        {:else}
                            <a
                                href={editContentDataUrl(selectedItem.id)}
                                class="btn btn-default w-100 text-start mtapp-selected-item"
                                data-content-data-id={selectedItem.id}
                                target="_blank">
                                <span class="icon">{@html contentDataStatusIcon(selectedItem.status)}</span>
                                <span class="label">{selectedItem.label}</span>
                            </a>
                        {/if}
                        {#if !item.radio}
                            <button
                                type="button"
                                class="btn btn-default"
                                onclick={preventDefault(() => contentDataUp(loopIndex))}
                                disabled={loopIndex === 0}
                                aria-label="Move Up">
                                <svg role="img" class="mt-icon--secondary mr-0">
                                    <use xlink:href={staticPath + '/images/sprite.svg#ic_tri-up'}></use>
                                </svg>
                            </button>
                            <button
                                type="button"
                                class="btn btn-default"
                                onclick={preventDefault(() => contentDataDown(loopIndex))}
                                disabled={loopIndex === selectedItems.length - 1}
                                aria-label="Move Down">
                                <svg role="img" class="mt-icon--secondary mr-0">
                                    <use xlink:href={staticPath + '/images/sprite.svg#ic_tri-down'}></use>
                                </svg>
                            </button>
                        {/if}
                        <button
                            type="button"
                            class="btn btn-default"
                            onclick={preventDefault(() => contentDataRemove(loopIndex))}
                            aria-label="Remove">
                            <svg role="img" class="mt-icon--secondary mr-0">
                                <use xlink:href={staticPath + '/images/sprite.svg#ic_trash'}></use>
                            </svg>
                        </button>
                    </div>
                {/each}
            </div>
        {/if}
        <div class="d-flex gap-3 mt-3">
            <button type="button" class="btn btn-default mtapp-select" onclick={modalOpen}>{selectButtonLabel}</button>
            {#if item.modalCreate}
                <button type="button" class="btn btn-default mtapp-create" data-bs-dismiss="modal" onclick={createContentData}>
                    {createButtonLabel}
                </button>
            {:else}
                <a class="btn btn-default mtapp-create" target="_blank" href={createContentDataUrl()}>{createButtonLabel}</a>
            {/if}
            {#if !item.modalEdit}
                <button type="button" class="btn btn-default ms-2 mtapp-update" onclick={showSelectedDataLabel}>
                    {mtappVars.translate['Update List']}
                </button>
            {/if}
        </div>
    </div>

    <!-- コンテンツデータ選択用モーダル -->
    <div id={modalId} class="modal fade" tabindex="-1" data-bs-keyboard="false" data-bs-backdrop="static" role="dialog">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{item.label}</h5>
                </div>
                <div class="modal-body">
                    {#if allContentDataIds.length}
                        <div class="d-flex mb-4 align-items-center gap-2">
                            <input
                                id={searchInputId}
                                class="form-control me-2 w-50"
                                type="search"
                                bind:value={searchText}
                                placeholder={mtappVars.translate['Search']}
                                aria-label={mtappVars.translate['Search']} />
                            <button class="btn btn-primary" type="button" onclick={search}>{mtappVars.translate['Search']}</button>
                            <button class="btn btn-default" type="button" onclick={resetSearch}>{mtappVars.translate['Reset']}</button>
                        </div>
                    {/if}
                    {#if responseItems.length}
                        <table id={tableId} class="table mt-table table-striped">
                            <thead>
                                <tr>
                                    <th scope="col" style="width: 3rem;">&nbsp;</th>
                                    <th scope="col">{item.dataLabelName || mtappVars.translate['Title']}</th>
                                    {#if typeof item.options !== 'undefined' && Array.isArray(item.options)}
                                        {#each item.options as option}
                                            <th scope="col" class={option.fieldId}>{option.label}</th>
                                        {/each}
                                    {/if}
                                </tr>
                            </thead>
                            <tbody>
                                {#each responseItems as contentData (contentData.id)}
                                    <tr>
                                        <td class="text-center">
                                            {#if item.radio}
                                                <input type="radio" bind:group={radioData} value={contentData.id} onchange={radioChange} />
                                            {:else if item.data.includes(contentData.id)}
                                                <input
                                                    type="checkbox"
                                                    bind:checked={contentData.checked}
                                                    value={contentData.id}
                                                    onchange={() => {
                                                        checkboxChange(contentData);
                                                    }} />
                                            {:else}
                                                <input
                                                    type="checkbox"
                                                    bind:checked={contentData.checked}
                                                    value={contentData.id}
                                                    disabled={isDisabled}
                                                    onchange={() => {
                                                        checkboxChange(contentData);
                                                    }} />
                                            {/if}
                                        </td>
                                        <td>{@html contentDataStatusIcon(contentData.status)}{contentData.label}</td>
                                        {#if typeof item.options !== 'undefined' && Array.isArray(item.options)}
                                            {#each item.options as option (option.data)}
                                                <td class={option.data}>
                                                    {#if typeof contentData.associativeData !== 'undefined' && typeof contentData.associativeData['field_' + option.fieldId] !== 'undefined'}
                                                        {@html contentData.associativeData['field_' + option.fieldId]}
                                                    {/if}
                                                </td>
                                            {/each}
                                        {/if}
                                    </tr>
                                {/each}
                            </tbody>
                        </table>
                    {:else}
                        <p>{mtappVars.translate['Content Data Not Found.']}</p>
                    {/if}
                </div>
                <div class="modal-footer d-flex align-items-center justify-content-between gap-2">
                    <div class="btn-group mb-0" role="group">
                        {#if item.modalCreate}
                            <button type="button" class="btn btn-default mtapp-create" data-bs-dismiss="modal" onclick={createContentData}>
                                {mtappVars.translate['Create']}
                            </button>
                        {:else}
                            <a class="btn btn-default mtapp-create" target="_blank" href={createContentDataUrl()}>
                                {mtappVars.translate['Create']}
                            </a>
                            <button type="button" class="btn btn-secondary mtapp-update" onclick={preventDefault(resetFilter)}>
                                {mtappVars.translate['Update List']}
                            </button>
                        {/if}
                    </div>
                    {#if item.data.length}
                        <div>
                            <span>{item.data.length}</span>
                            {#if item.maxCount > 0}
                                <span> / {item.maxCount}</span>
                            {/if}
                            <span>{mtappVars.translate[' items selected']}</span>
                        </div>
                    {/if}
                    {#if responseTotalResults > paginateLimit}
                        <div class="btn-group mb-0" role="group">
                            <button
                                type="button"
                                class="btn btn-default"
                                onclick={preventDefault(getPrevPage)}
                                disabled={currentOffset - paginateLimit < 0}>
                                {mtappVars.translate['Prev']}
                            </button>
                            <button type="button" class="btn btn-default" disabled>{currentPage} / {totalPages}</button>
                            <button
                                type="button"
                                class="btn btn-default"
                                onclick={preventDefault(getNextPage)}
                                disabled={responseTotalResults <= currentOffset + paginateLimit * 1}>
                                {mtappVars.translate['Next']}
                            </button>
                        </div>
                    {/if}
                    <div class="btn-group mb-0" role="group">
                        <button type="button" class="btn btn-primary mtapp-save" data-bs-dismiss="modal" onclick={saveIds}>
                            {mtappVars.translate['Save Changes']}
                        </button>
                        <button type="button" class="btn btn-default mtapp-cancel" data-bs-dismiss="modal" onclick={cancel}>
                            {mtappVars.translate['Cancel']}
                        </button>
                        {#if filtered}
                            <button type="button" class="btn btn-default mtapp-all-data" onclick={resetFilter}>
                                {mtappVars.translate['All Items']}
                            </button>
                        {:else if item.data.length}
                            <button type="button" class="btn btn-default mtapp-filter" onclick={selectedFilter}>
                                {mtappVars.translate['Selected Items']}
                            </button>
                        {/if}
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- コンテンツデータ新規作成・編集用モーダル -->
    <div
        id={modalEditId}
        class="modal fade"
        tabindex="-1"
        aria-labelledby={modalEditId + '-label'}
        data-bs-backdrop="static"
        data-bs-keyboard="false">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id={modalEditId + '-label'}>
                        {@html mtappVars.translate['Edit Content Data']}
                    </h5>
                </div>
                <div class="modal-body">
                    <div class="ratio ratio-16x9">
                        <iframe class="embed-responsive-item" id={iframeId} src="" title=""></iframe>
                    </div>
                </div>
                <div class="modal-footer">
                    {#if createMode}
                        <button type="button" class="btn btn-primary mtapp-select" onclick={select}>
                            {mtappVars.translate['Select']}
                        </button>
                    {/if}
                    <button type="button" class="btn btn-default mtapp-close" data-bs-dismiss="modal" onclick={cancelEdit}>
                        {createMode ? mtappVars.translate['Cancel'] : mtappVars.translate['Close']}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
